export default [
  { value: '+/-10', label: '+/-10' },
  { value: '+/-5', label: '+/-5' },
  { value: '+/-10', label: '+/-10' },
  { value: '+10/-20', label: '+10/-20' },
  { value: '+10/-30', label: '+10/-30' },
  { value: 'Maximum', label: 'Maximum' },
];
